import axios from './axios';

// Call Conversion API Services
export const callConversionService = {
  // Get all call conversions with optional filters
  getConversions: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        queryParams.append(key, value);
      }
    });

    const response = await axios.get(`/call-conversions?${queryParams}`);
    return response.data;
  },

  // Create a new call conversion
  createConversion: async (data) => {
    const response = await axios.post('/call-conversions', data);
    return response.data;
  },

  // Update a call conversion
  updateConversion: async (id, data) => {
    const response = await axios.put(`/call-conversions/${id}`, data);
    return response.data;
  },

  // Delete a call conversion
  deleteConversion: async (id) => {
    const response = await axios.delete(`/call-conversions/${id}`);
    return response.data;
  },

  // Get a single call conversion by ID
  getConversionById: async (id) => {
    const response = await axios.get(`/call-conversions/${id}`);
    return response.data;
  }
};

export default callConversionService;
